import styled from 'styled-components';

import ShippersTooltip from './ShippersTooltip';

export default styled(ShippersTooltip)`
  .list {
    display: flex;
    flex-direction: column;
    width: 300px;
    border-radius: 4px;
    overflow: hidden;
  }
  .shipper {
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 0.8rem;
    background-color: var(--grey100);
    color: var(--grey700);
    border-bottom: 1px solid var(--grey200);
    &:last-child {
      border-bottom: 0;
    }
    &__tags {
      margin-left: 0.8rem;
    }

    .shipper__company_name {
      display: flex;
      align-items: center;
    }

    .shipper__order_id {
      background: var(--white);
      padding: 0.4rem;
      border-radius: 0.4rem;
      margin-right: 0.8rem;
    }
  }

  .shipper.upgrade {
    background-color: var(--deep-purple100);
  }
`;
